export default __webpack_public_path__ + "static/media/done.86c00162.svg";